<div class="tw-space-y-4 tw-max-h-[60vh] tw-overflow-y-auto">
    <p>{{ 'terms.privacy.updated' | transloco }}</p>
    <p>{{ 'terms.privacy.description' | transloco }}</p>
    <section
        class="tw-p-2 tw-rounded tw-border tw-border-[var(--p-content-border-color)]"
        [innerHtml]="terms"
        [attr.aria-label]="'terms.privacy.header' | transloco"
    ></section>
</div>
<div class="tw-flex tw-items-center tw-gap-2 tw-mt-4 tw-pt-4 tw-border-t tw-border-[var(--p-content-border-color)]">
    <p-checkbox
        [(ngModel)]="accept"
        [binary]="true"
        inputId="accept_terms_primeng"
        [attr.aria-label]="'terms.privacy.acceptLabel' | transloco">
    </p-checkbox>
    <label for="accept_terms_primeng" class="tw-text-[var(--p-text-color)]">{{ 'terms.privacy.acceptLabel' | transloco }}</label>
    <p-button
        class="tw-ml-auto"
        [disabled]="!accept"
        [loading]="saving"
        (onClick)="submit()"
        (keydown.enter)="submit()"
        [label]="'terms.privacy.acceptButton' | transloco">
    </p-button>
</div>
